import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useRouter } from "src/hooks/useRouter";
import { checkServiceId, getCashUserStatus } from "src/service/pay";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { urlNameValidation } from "src/utils/validation";
import "./SiteNew.style.scss";
import { useRecoilState } from "recoil";
import { productKeyAtom } from "src/atoms";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import { useShowSiteUrl } from "src/hooks/recoil/useShowSiteUrl";
import { useQueryClient } from "react-query";
import {
  ICheckServiceIdReq,
  ICreateServiceSiteReq,
} from "src/service/types/pay.type";
import styles from "./index.module.scss";
import Tooltip from "components/Common/Tooltip";
import FormInput from "components/Common/Form/Input/FormInput";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import { createServiceSiteSchema } from "./SiteNew.schema";
import { FormContainer } from "components/Common/Form/Input/FormContainer";
import { useEffect, useCallback } from "react";
import { useWatch } from "react-hook-form";
import useCreateServiceSite from "src/hooks/api/pay/useCreateService";
import { useTranslation } from "react-i18next";

interface ISiteNewModalProps {
  showSiteNewModal: boolean;
  serviceBillUid: string;
  hideModal: () => void;
}
const SiteNewModal = ({
  showSiteNewModal,
  serviceBillUid,
  hideModal,
}: ISiteNewModalProps) => {
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  const route = useRouter();
  const [regionId, setRegionId] = useState<string>(
    route.lang === "ko" ? "ap-northeast-2" : "us-east-1"
  );
  const [makeServiceLoading, setMakeServiceLoading] = useState<boolean>(false);
  const [isCheckingServiceId, setIsCheckingServiceId] =
    useState<boolean>(false);
  const [isUrlPrefixValid, setIsUrlPrefixValid] = useState<boolean>(false);
  const { isOciProduct, isDspProduct, isDspmProduct, isWrapsody, isWrapsodyEco, isFiresideProduct, isMindSatProduct } = useProductFlags();
  const isShowSiteUrl = useShowSiteUrl();
  const { t } = useTranslation();
  // const makeService = async () => {
  //   try {
  //     // this.commonStore.setLoading(true)
  //     setMakeServiceLoading(false);
  //     try {
  //       // 사이트 생성 (기존)
  //       const createSiteReq = {
  //         urlPrefix: serviceId,
  //         product: getProductFromSessionStorage(),
  //         // product: 'WRAPSODY_ECO',
  //         region: regionId,
  //         serviceName: serviceName,
  //         serviceBillUid: code, // 실제 사이트 생성할때 잘 들어가는지 확인
  //       };
  //       // 테넌시 생성 (New)
  //       const createTenancyReq = {
  //         urlPrefix: serviceId,
  //         product: getProductFromSessionStorage(),
  //         // product: 'WRAPSODY_ECO',
  //         region: regionId,
  //         serviceName: serviceName,
  //         serviceBillUid: code, // 실제 사이트 생성할때 잘 들어가는지 확인
  //       };
  //       console.log("createSiteReq", createSiteReq);
  //       // setMakeServiceLoading(true);
  //       // const siteResult = await createServiceSite({ ...createSiteReq });

  //       // if (siteResult) {
  //       //   setMakeServiceLoading(false);
  //       //   // notifySuccess(
  //       //   //   t("siteManagement.createSite.createStatusStart")
  //       //   // );
  //       //   // route.goConsole();
  //       //   if (isOciProduct) {
  //       //     alert(
  //       //       t(
  //       //         "siteManagement.createSite.createStatusComplete"
  //       //       )
  //       //     );
  //       //     if (productKey === "WRAPSODY") route.productReload({ productKey });
  //       //     else if (productKey === "WRAPSODY_ECO")
  //       //       // route.productReload({ productKey, urlPrefix: serviceName });
  //       //       route.productReload({ productKey, urlPrefix: serviceId });
  //       //   } else {
  //       //     alert(
  //       //       t("siteManagement.createSite.createStatusStart")
  //       //     );
  //       //     route.goConsole();
  //       //     queryClient.clear();
  //       //     route.reload();
  //       //   }
  //       // }
  //     } catch (error: any) {
  //       if (error?.errorCode && error?.errorMessage) {
  //         notifyError(error.errorMessage);

  //         const checkCashStatus = await getCashUserStatus({
  //           product: [getProductFromSessionStorage()],
  //         });
  //         if (!["APPROVED", "DONE"].includes(checkCashStatus.status)) {
  //           route.goSiteType();
  //         }
  //       }
  //     }
  //     // this.commonStore.setLoading(false)
  //   } catch (error: any) {
  //     if (error?.errorCode && error?.errorMessage) {
  //       notifyError(error.errorMessage);
  //     }
  //   }
  // };

  const siteNewForm = useForm<ICreateServiceSiteReq>({
    resolver: yupResolver(createServiceSiteSchema(isDspProduct)),
    defaultValues: {
      // urlPrefix: serviceId,
      product: getProductFromSessionStorage(),
      // product: 'WRAPSODY_ECO',
      region: regionId,
      // serviceName: serviceName,
      serviceBillUid: serviceBillUid, // 실제 사이트 생성할때 잘 들어가는지 확인
    },
    mode: "onChange",
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    getFieldState,
    setError,
    clearErrors,
    getValues,
    setValue,
  } = siteNewForm;

  // code 값이 변경될 때 form의 serviceBillUid 값을 업데이트
  useEffect(() => {
    // console.log("SiteNewModal - code changed:", code);
    if (serviceBillUid) {
      setValue("serviceBillUid", serviceBillUid);
      // console.log("SiteNewModal - serviceBillUid set to:", code);
    }
  }, [serviceBillUid, setValue]);
  const { errors, isValid } = formState;
  const queryClient = useQueryClient();
  const { mutateCreateServiceSite, isCreateServiceSiteLoading } =
    useCreateServiceSite({
      onSuccess: () => {
        if (isOciProduct) {
          alert(t("siteManagement.createSite.createStatusComplete"));
          if (productKey === "WRAPSODY") route.productReload({ productKey });
          else if (productKey === "WRAPSODY_ECO")
            // route.productReload({ productKey, urlPrefix: serviceName });
            route.productReload({
              productKey,
              urlPrefix: getValues("urlPrefix"),
            });
        } else {
          alert(t("siteManagement.createSite.createStatusStart"));
          route.goConsole();
          queryClient.clear();
          route.reload();
        }
      },
      onError: async (error: any) => {
        if (error?.errorCode && error?.errorMessage) {
          // notifyError(error.errorMessage);

          const checkCashStatus = await getCashUserStatus({
            product: [getProductFromSessionStorage()],
          });
          if (!["APPROVED", "DONE"].includes(checkCashStatus.status)) {
            route.goSiteType();
          }
        }
      },
    });
  const onSubmit = (data: ICreateServiceSiteReq) => {
    // console.log("onSubmit", data);
    const { urlPrefix, product, region, serviceName, serviceBillUid } = data;
    const createSiteReq = {
      urlPrefix,
      product,
      region,
      serviceName,
      serviceBillUid,
      cloudProvider:
        isOciProduct || isFiresideProduct || isMindSatProduct ? "OCI" : "AWS",
    };
    // console.log("createSiteReq", createSiteReq);
    mutateCreateServiceSite(createSiteReq);
  };
  // urlPrefix 값을 감시
  const watchedUrlPrefix = useWatch({
    control,
    name: "urlPrefix",
  });
  // serviceName 값을 감시
  const watchedServiceName = useWatch({
    control,
    name: "serviceName",
  });
  // 서비스 ID 유효성 검사 함수
  const validateServiceId = useCallback(
    async (urlPrefix: string) => {
      if (!urlPrefix || urlPrefix.trim() === "") {
        setError("urlPrefix", {
          message: "siteManagement.createSiteModal.placeholder.siteId",
        });
        setIsUrlPrefixValid(false);
        return;
      }

      setIsCheckingServiceId(true);
      setIsUrlPrefixValid(false);

      try {
        const checkReq: ICheckServiceIdReq = {
          urlPrefix: urlPrefix.trim(),
          product: getProductFromSessionStorage(),
          serviceBillUid: serviceBillUid,
        };
        if (isWrapsody || isWrapsodyEco) {
          checkReq.cloudProvider = isOciProduct ? "OCI" : "AWS";
        }
        await checkServiceId(checkReq).then((res) => {
          if (res && urlNameValidation(urlPrefix)) {
            clearErrors("urlPrefix");
            setIsUrlPrefixValid(true);
          } else {
            setError("urlPrefix", {
              message: "siteManagement.createSite.prohibited",
            });
            setIsUrlPrefixValid(false);
          }
        });
      } catch (error: any) {
        console.log("error", error?.message);
        setIsUrlPrefixValid(false);
        if (error?.message === "DUPLICATE_DATA") {
          setError("urlPrefix", {
            message: "siteManagement.createSiteModal.alert.isDuplicate",
          });
        } else if (error?.message === "INVALID_DATA") {
          setError("urlPrefix", {
            message: "siteManagement.createSiteModal.placeholder.siteId",
          });
        } else if (error?.message === "ENABLE_URL") {
          setError("urlPrefix", {
            message: "siteManagement.createSiteModal.placeholder.siteId",
          });
        }
      } finally {
        setIsCheckingServiceId(false);
      }
    },
    [
      clearErrors,
      serviceBillUid,
      isOciProduct,
      isWrapsody,
      isWrapsodyEco,
      setError,
    ]
  );

  // urlPrefix 변경 시 디바운스 적용하여 API 호출
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (watchedUrlPrefix) {
        if (!errors.urlPrefix) {
          validateServiceId(watchedUrlPrefix);
        }
      } else {
        setIsUrlPrefixValid(false);
      }
    }, 500); // 500ms 디바운스

    return () => clearTimeout(timeoutId);
  }, [watchedUrlPrefix, validateServiceId, errors.urlPrefix]);
  // useEffect(() => {
  //   const validateForm = async () => {
  //     try {
  //       const currentValues = getValues();
  //       const valid = await createServiceSiteSchema.validate(currentValues, {
  //         abortEarly: false,
  //       });
  //       console.log("valid", valid);
  //     } catch (err) {
  //       console.log("err", err);
  //     }
  //   };

  //   validateForm();
  // }, [createServiceSiteSchema, getValues, formState.isDirty]);
  return (
    <Modal
      show={showSiteNewModal}
      backdrop="static"
      onHide={hideModal}
      className="siteNewModal"
      style={{ opacity: 1 }}
    >
      <FormProvider {...siteNewForm}>
        <Modal.Header closeButton>
          <label>{t("siteManagement.createSiteModal.title")}</label>
        </Modal.Header>
        <FormContainer onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body style={{ zIndex: 9999, overflow: "visible" }}>
            {/* {isLoading ? <Loading /> : ''} */}
            {/* <div className={styles.siteNew}> */}

            <div className={styles.formItem} style={{ marginBottom: "12px" }}>
              <div
                className={`flex align-center ${isOciProduct &&
                  productKey === "WRAPSODY_ECO" &&
                  "flex-row-reverse"
                  }`}
              >
                <FormInput
                  required={true}
                  isClearBtn={false}
                  label={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ marginRight: "4px" }}>
                        {t(
                          `siteManagement.createSiteModal.${isShowSiteUrl ? "siteUrl" : "siteId"
                          }`
                        )}
                      </span>
                      <Tooltip
                        iconType="question"
                        iconColor="question"
                        placement="top"
                        isShowCard={false}
                        innerWidth={`${isShowSiteUrl ? "140px" : "300px"}`}
                      // prevText={}
                      >
                        {t(
                          `siteManagement.createSiteModal.tooltip.${isShowSiteUrl ? "siteUrl" : "siteId"
                          }`
                        )}
                      </Tooltip>
                    </div>
                  }
                  name="urlPrefix"
                  // value={serviceId}
                  register={register}
                  errors={errors}
                  success={{
                    isSuccess:
                      !!watchedUrlPrefix &&
                      !!isUrlPrefixValid &&
                      !errors.urlPrefix,
                    message: "siteManagement.createSiteModal.alert.validId",
                  }}
                  placeholder={
                    !isShowSiteUrl
                      ? t(`siteManagement.createSiteModal.placeholder.siteId`)
                      : ""
                  }
                >
                  {isShowSiteUrl && (
                    <div className="mg mb-12">
                      <span className="text text--black">
                        {isOciProduct && productKey === "WRAPSODY_ECO"
                          ? t(`siteManagement.createSiteModal.suffix.ociEco`)
                          : isDspProduct
                            ? ".fasoodsp.com" : isDspmProduct ? ""
                              : t(
                                `siteManagement.createSiteModal.suffix.${productKey === "WRAPSODY" ? "wrapsody" : "eco"
                                }`
                              )}
                      </span>
                    </div>
                  )}
                  {/* 서비스 ID 유효성 검사 결과 표시 */}
                  {/* {watchedUrlPrefix && (
                          <div className="mt-8">
                            {isCheckingServiceId ? (
                              <div className="flex align-center">
                                <Spinner
                                  animation="border"
                                  role="status"
                                  size="sm"
                                />
                                <span className="ml-8 text text--gray">
                                  ID 확인 중...
                                </span>
                              </div>
                            ) : (
                              serviceIdValidationMessage && (
                                <span
                                  className={`text ${
                                    isServiceId
                                      ? "text--success"
                                      : "text--error"
                                  }`}
                                >
                                  {serviceIdValidationMessage}
                                </span>
                              )
                            )}
                          </div>
                        )} */}
                </FormInput>
              </div>
            </div>

            {/* 사이트 이름 */}
            <FormInput
              required={true}
              label={t("siteManagement.createSiteModal.siteName")}
              name="serviceName"
              // isClearBtn={false}
              // value={serviceName}
              register={register}
              errors={errors}
              placeholder={t(
                `siteManagement.createSiteModal.placeholder.siteName`
              )}
              max={128}
            // className={`form-control custom-form width 370`}
            />

            {/* 2025-09-29 서버 위치 필드 가림 -> 국문은 서울, 영문은 미국 동부로 사이트 생성 요청(국문에서 미국 동부 체크 후 생성시 오류 발생) */}
            {/* {!isDspProduct && !isFiresideProduct && (
              <div style={{ marginTop: "12px" }}>
                <FormSelect
                  label={t(
                    "siteManagement.createSiteModal.serverLocation.fieldname"
                  )}
                  control={control}
                  errors={errors}
                  name="regionId"
                  defaultValue={regionId}
                  options={[
                    {
                      label: t(
                        "siteManagement.createSiteModal.serverLocation.option_1"
                      ),
                      value: "ap-northeast-2",
                    },
                    {
                      label: t(
                        "siteManagement.createSiteModal.serverLocation.option_2"
                      ),
                      value: "us-east-1",
                      disabled: route?.lang === "ko" ? true : false,
                    },
                  ]}
                  placeholder={t(
                    `siteManagement.createSiteModal.serverLocation.placeholder`
                  )}
                  // value={regionId}
                />
              </div>
            )} */}

            {/* </div> */}
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button
              // type="button"
              variant="secondary"
              className="btn btn-gray btn-40 width min-w-73"
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: "Pretendard",
              }}
              onClick={hideModal}
            >
              {t("common.cancelBtn")}
            </Button>
            <Button
              // type="button"
              type="submit"
              variant="primary"
              disabled={
                !isValid ||
                !!errors.urlPrefix ||
                !!errors.serviceName ||
                isCheckingServiceId ||
                (!!watchedUrlPrefix && !isUrlPrefixValid) ||
                !watchedUrlPrefix ||
                !watchedServiceName
              }
              // onClick={makeService}
              className="btn btn-40 width min-w-73 bg-[#3182F6] text-white"
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: "Pretendard",
                backgroundColor: "#3182F6",
                color: "#fff",
              }}
            >
              <div className="flex align-center justify-center gap-2">
                {isCreateServiceSiteLoading && (
                  <Spinner animation="border" role="status" size="sm" />
                )}
                <span>{t("common.okBtn")}</span>
              </div>
            </Button>
          </Modal.Footer>
        </FormContainer>
      </FormProvider>
    </Modal>
  );
};

export default SiteNewModal;
